/**
 * Cart qty +/- — auto-submit cart form (debounced 600ms).
 *
 * Markup: <div data-kb-qty><button data-qty-dec/><input data-qty-input/><button data-qty-inc/></div>
 * Form: <form class="woocommerce-cart-form">
 *
 * Po zmianie qty:
 *  - update input.value
 *  - trigger native change event (Woo native listeners + accessibility)
 *  - debounced form.submit() → POST update_cart → Woo recalculates totals
 *
 * Edge cases:
 *  - qty=0 → Woo treats as remove (native behavior)
 *  - input min/max respected
 */

(function () {
  if (typeof window === 'undefined') return;

  function initCartQty() {
    const form = document.querySelector('.woocommerce-cart-form');
    if (!form) return;

    let submitTimer = null;
    const SUBMIT_DELAY = 700;

    function scheduleSubmit() {
      if (submitTimer) clearTimeout(submitTimer);
      submitTimer = setTimeout(() => {
        // Aktualizujemy hidden field żeby Woo wiedział że to update_cart
        const hidden = form.querySelector('input[name="update_cart"]');
        // Rdzeniowy skrypt koszyka wyłącza to pole na starcie, a wyłączone pole nie idzie
        // w POST — WooCommerce nie widział wtedy `update_cart` i nie zapisywał ilości.
        if (hidden) { hidden.disabled = false; hidden.value = '1'; }
        form.submit();
      }, SUBMIT_DELAY);
    }

    function clampValue(input, raw) {
      let v = parseInt(raw, 10);
      if (isNaN(v) || v < 0) v = 0;
      const min = parseInt(input.getAttribute('min') || '0', 10);
      const max = parseInt(input.getAttribute('max') || '0', 10);
      if (v < min) v = min;
      if (max > 0 && v > max) v = max;
      return v;
    }

    form.querySelectorAll('[data-kb-qty]').forEach((grp) => {
      // Idempotent guard — initCartQty jest wołany na każdy `updated_cart_totals`
      // i `wc_fragments_refreshed`. Bez tego flagu każde update doliczało zestaw
      // listenerów na +/- buttonach i input → na cart page po kilku zmianach qty
      // Safari iOS akumulował setki closures i crashował.
      if (grp.__kbBound) return;
      grp.__kbBound = true;
      const input = grp.querySelector('[data-qty-input]');
      if (!input) return;
      // „+" i „−" podpina pdp-variations.js (initQtyControls) i po zmianie wysyła `change`.
      // Drugie podpięcie tutaj dawało skok o 2 na jedno kliknięcie.

      input.addEventListener('change', () => {
        // User typed manually
        const v = clampValue(input, input.value);
        input.value = v;
        scheduleSubmit();
      });

      // Stop accidental Enter submit (let debounce handle it)
      input.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          scheduleSubmit();
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCartQty);
  } else {
    initCartQty();
  }

  // Po wc-cart-fragments refresh albo theme re-mount
  document.body.addEventListener('updated_cart_totals', initCartQty);
  document.body.addEventListener('wc_fragments_refreshed', initCartQty);
})();
